import ParenthesisClass from '../parenthesisClass';

const closeParenthesis = new ParenthesisClass(')', 'close');

export default closeParenthesis;
